import { DefaultRootState } from '~/types'
import isFlagEnabled from '~/lib/isFlagEnabled'
import { getUserIdentity } from '~/redux-modules/identity'

import { PROVISIONED_UI_FLAGS } from './constants'

export const selectFlags = (state: DefaultRootState) => {
    const identity = getUserIdentity(state)

    return {
        isAllWorkspacesFeatureEnabled: isFlagEnabled(
            identity,
            PROVISIONED_UI_FLAGS.UI_ALL_TEAM_WORKSPACES_PHASE_1,
            'true',
        ),
        isTeamAnalyticsFeatureEnabled: isFlagEnabled(
            identity,
            PROVISIONED_UI_FLAGS.RELEASE_TEAM_WORKSPACE_SPEND_FE,
            'true',
        ),
    }
}
